import { Throttle, MagicConfigMixin } from '@gig/magic-common';
import { __extends, __awaiter, __generator, __decorate, __metadata } from 'tslib';
import { Watch, Component, Mixins } from 'vue-property-decorator';
import { magic } from '@gig/magic-sdk';
import { USER_LOGGED_IN_UPDATED, CLEAR_REWARD_COUNT, REWARD_COUNT } from '@gig/magic-messages';
import { notificationService } from '@gig/magic-messaging';

/**
 * Displays a notification whenever a new reward
 * is received or when a user claims a reward
 */
var RewardPrompterComponent = /** @class */ (function (_super) {
    __extends(RewardPrompterComponent, _super);
    function RewardPrompterComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.eventUnsub = null;
        _this.userLoggedInSubscription = null;
        _this.clearRewardCountSubscription = null;
        _this.isLoading = false;
        _this.rewardCount = 0;
        return _this;
    }
    RewardPrompterComponent.prototype.created = function () {
        var _this = this;
        this.userLoggedInSubscription = window.eventBus.subscribe(USER_LOGGED_IN_UPDATED, function (event) {
            _this.onSessionChange(event.payload);
        }, { replay: true });
        this.clearRewardCountSubscription = window.commandBus.subscribe(CLEAR_REWARD_COUNT, function () {
            _this.clearRewardCount();
        });
        this.showNewRewardNotification();
    };
    RewardPrompterComponent.prototype.destroyed = function () {
        var _a;
        this.unsubscribe();
        (_a = this.userLoggedInSubscription) === null || _a === void 0 ? void 0 : _a.unsubscribe();
    };
    RewardPrompterComponent.prototype.render = function () {
        return null;
    };
    RewardPrompterComponent.prototype.onSessionChange = function (isLoggedIn) {
        var _this = this;
        if (!isLoggedIn) {
            this.unsubscribe();
            return;
        }
        this.fetchRewardCount();
        this.eventUnsub = magic.events.rewardReceived(function () {
            return _this.fetchRewardCount();
        }).unsub;
    };
    /**
     * Throttle 5000 because is the time it takes to close the previous notification
     * one we only want to show 1 notification at the same time with the total
     * number of new rewards.
     */
    RewardPrompterComponent.prototype.showNewRewardNotification = function () {
        this.rewardCount &&
            notificationService.show(this.$t('new-reward-notification.text', {
                number: this.rewardCount,
            }), {
                uniqueID: 'new-reward-notification-text',
            });
    };
    RewardPrompterComponent.prototype.unsubscribe = function () {
        var _a;
        if (!this.eventUnsub) {
            return;
        }
        (_a = this.clearRewardCountSubscription) === null || _a === void 0 ? void 0 : _a.unsubscribe();
        this.clearRewardCount();
        this.eventUnsub();
        this.eventUnsub = null;
    };
    RewardPrompterComponent.prototype.fetchRewardCount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var amount, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.isLoading) {
                            return [2 /*return*/];
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        this.isLoading = true;
                        return [4 /*yield*/, magic.methods.rewards.newlyAwardedTokens()];
                    case 2:
                        amount = _a.sent();
                        this.rewardCount = amount;
                        window.eventBus.publish(REWARD_COUNT, amount);
                        return [3 /*break*/, 5];
                    case 3:
                        e_1 = _a.sent();
                        // Do not notify the error to avoid confusing the user as
                        // loading the reward count is not explicitly requested by the user
                        console.error(e_1);
                        return [3 /*break*/, 5];
                    case 4:
                        this.isLoading = false;
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    RewardPrompterComponent.prototype.clearRewardCount = function () {
        this.rewardCount = 0;
        window.eventBus.publish(REWARD_COUNT, 0);
    };
    __decorate([
        Throttle(5000),
        Watch('rewardCount'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], RewardPrompterComponent.prototype, "showNewRewardNotification", null);
    RewardPrompterComponent = __decorate([
        Component({
            name: 'reward-prompter',
        })
    ], RewardPrompterComponent);
    return RewardPrompterComponent;
}(Mixins(MagicConfigMixin)));

export { RewardPrompterComponent };
